'use client';
/**
 * Logo cloud with real Indian FMCG brand logos via Brandfetch Logo Link CDN.
 *
 * URL path order: domain/w/{w}/h/{h}/theme/{theme}/fallback/{fallback}/type/{type}?c={clientId}
 * Ref: /Users/princemendiratta/Documents/startup/workspace/tree-1/apps/batcave/alfred/src/services/brandfetch-service.ts
 */

const BRANDFETCH_CLIENT_ID = '1idozT0NfLSlO73Gf1q';

function brandLogo(domain: string) {
  // No type, no theme → Brandfetch serves the best available variant
  return `https://cdn.brandfetch.io/${domain}/w/400/h/120/fallback/404?c=${BRANDFETCH_CLIENT_ID}`;
}

const brands = [
  { name: 'Hindustan Unilever', domain: 'hul.co.in' },
  { name: 'ITC Limited', domain: 'itcportal.com' },
  { name: 'Dabur', domain: 'dabur.com' },
  { name: 'Marico', domain: 'marico.com' },
  { name: 'Godrej Consumer', domain: 'godrejcp.com' },
  { name: 'Britannia', domain: 'britannia.co.in' },
];

export default function LogoCloud() {
  return (
    <section className="border-y border-border py-10 sm:py-12">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <p className="text-center text-xs font-medium uppercase tracking-[0.2em] text-muted-foreground">
          Powering decisions at India&apos;s leading FMCG companies
        </p>
        <div
          className="mt-8 flex flex-wrap items-center justify-center gap-x-10 gap-y-6 sm:gap-x-14"
          role="list"
          aria-label="Client logos"
        >
          {brands.map((b) => (
            <div key={b.domain} className="flex items-center" role="listitem">
              <img
                src={brandLogo(b.domain)}
                alt={`${b.name} logo`}
                width={400}
                height={120}
                loading="lazy"
                className="max-h-8 w-auto max-w-[120px] object-contain opacity-50 grayscale transition-all hover:opacity-80 hover:grayscale-0 sm:max-h-10 sm:max-w-[140px]"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  const fallback = target.nextElementSibling as HTMLElement;
                  if (fallback) fallback.style.display = 'block';
                }}
              />
              <span
                className="hidden select-none font-serif text-base font-semibold text-foreground/20 sm:text-lg"
                aria-hidden="true"
              >
                {b.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
